import { Component, Vue } from "vue-property-decorator";
import { Config } from "@/plugins/config";

@Component
export default class ContentMixin extends Vue {
  public imgBaseUrl: string =
    "https://d1mucuudiyut41.cloudfront.net/assets/eprep/";

  public fileSrc(file: string) {
    return Config.Files + file;
  }
}
